import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';

import { EditTableColumns } from '../../../containers/mask-overlays/mask-overlay/views/erp/components/tab-panels/positions/components/edit-table/types';
import { EditableEntityTable } from '../editable-entity-table/EditableEntityTable';

const LOOKUP_DATA: LookUp = {
  id: null,
  name: null,
  groupView: null,
  lookupType: null,
};

const newEntryMandatoryFields: (keyof LookUp)[] = ['name'];

export const ProjectKindTable = () => {
  const { t } = useTranslation();

  const cols = useMemo<EditTableColumns<LookUp>[]>(
    () => [
      {
        Header: t('COMMON.NAME'),
        accessor: 'name',
        width: 300,
        type: 'text',
        resizable: false,
      },
      {
        Header: t('COMMON.PROJECTKIND.GROUPVIEW'),
        accessor: 'groupView',
        width: 100,
        type: 'checkbox',
        resizable: false,
      },
    ],
    [t]
  );

  const handleTranformBeforeUpdate = (value: LookUp): LookUp => {
    const result: LookUp = { ...value, lookupType: LookupType.PROJEKT_TYPE };
    if (value.groupView !== undefined) {
      result.groupView = value.groupView ? -1 : 0;
    }
    return result;
  };

  return (
    <EditableEntityTable<LookUp>
      columns={cols}
      dataFields={LOOKUP_DATA}
      entity={Entities.lookUp}
      idType="number"
      sortByField="name"
      newEntryMandatoryFields={newEntryMandatoryFields}
      dataProviderProps={{
        vars: {
          type: LookupType.PROJEKT_TYPE,
        },
      }}
      transformBeforeUpdate={handleTranformBeforeUpdate}
      enableDelete
    />
  );
};
